import { Card } from 'react-bootstrap'
import Datasheet from './data/8502-ds.pdf'
import Factsheet from './data/8502-fs.pdf'

const Document = ({document, name, file}) => {
	return (
		<Card className="mb-3">
			<Card.Header>
				<Card.Title>{name}</Card.Title>
			</Card.Header>
			<Card.Body>
				<a
					className="btn btn-primary me-3"
					href={document}
					target="_blank"
					rel="noreferrer"
					>
					Open
				</a>
				<a
					className="btn btn-primary"
					href={document}
					target="_blank"
					rel="noreferrer"
					download={file}
					>
					Download
				</a>
			</Card.Body>
		</Card>
	)
}

const Documents = (props) => {
	return (
		<div className="container">
			<h1>Documents</h1>
			<div>
				<Document document={Datasheet} name="Datasheet" file="8502-ds.pdf" />
				<Document document={Factsheet} name="Factsheet" file="8502-fs.pdf" />
			</div>
		</div>
	)
}

export default Documents
